import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "iconfont icon-v-add"
}

import { computed, reactive, toRefs } from "vue";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import Avatar from "@/components/Avatar.vue";

interface VimData {
  host: string;
  headers: any;
  data: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarUpload',
  props: {
  avatar: {
    type: String,
    required: true,
    default: "/img/default-group.png",
  },
},
  emits: ["uploadSuccess"],
  setup(__props, { emit: emits }) {

const props = __props;



let avatar = computed(() => {
  return props.avatar;
});
const token = Auth.getToken();

const vimData = reactive<VimData>({
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + token,
  },
  data: {
    access_token: Auth.getToken(),
    type: "file",
  },
});

//上传成功回调
const handleSuccess = (response: any) => {
  emits("uploadSuccess", response.url);
};
const { host, headers, data } = toRefs(vimData);

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    action: _unref(host) + '/common/uploadMinio',
    headers: _unref(headers),
    data: _unref(data),
    "show-file-list": false,
    "on-success": handleSuccess
  }, {
    default: _withCtx(() => [
      (_unref(avatar))
        ? (_openBlock(), _createBlock(Avatar, {
            key: 0,
            size: "large",
            img: _unref(avatar)
          }, null, 8, ["img"]))
        : _createCommentVNode("", true),
      (!_unref(avatar))
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["action", "headers", "data"]))
}
}

})